import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();
  //state data

  const [isDashboard, setIsDashboard] = useState(false);
  const [isUsers, setIsUsers] = useState(false);
  const [isEmployees, setIsEmployees] = useState(false);
  const [isAdditionalFees, setIsAdditionalFees] = useState(false);
  const [isContainers, setIsContainers] = useState(false);
  const [isContainersSave, setIsContainersSave] = useState(false);
  const [isContainersFees, setIsContainersFees] = useState(false);
  const [isContainersType, setIsContainersType] = useState(false);
  const [isSettings, setIsSettings] = useState(false);
  const [isOrders, setIsOrders] = useState(false);
  const [isReferenceInformation, setIsReferenceInformation] = useState(false);
  const [isReport, setIsReport] = useState(false);
  const [isLContainers, setIsLContainers] = useState(false);
  const [isVFClients, setIsVFClients] = useState(false);
  const [isVFCalculation, setIsVFCalculation] = useState(false);
  const [isClientContainers, setIsClientContainers] = useState(false);
  const [isVehicles, setIsVehicles] = useState(false);
  const [isTracking, setIsTracking] = useState(false);
  const [isLGCompanies, setIsLGCompanies] = useState(false);
  const [isWarehouseRoot, setIsWarehouseRoot] = useState(false);
  const [isInvoices, setIsInvoices] = useState(false);
  const [isMInvoices, setIsMInvoices] = useState(false);
  const [isOInvoices, setIsOInvoices] = useState(false);
  const [isFRtransactions, setIsFRtransactions] = useState(false);
  const [isDocuments, setIsDocuments] = useState(false);
  const [isRequests, setIsRequests] = useState(false);
  const [isCRequests, setIsCRequests] = useState(false);
  const [isTempWarehouse, setIsTempWarehouse] = useState(false);
  const [isGTARoot, setIsGTARoot] = useState(false);
  const [isQuotes, setIsQuotes] = useState(false);
  const [isWebQuotation, setIsWebQuotation] = useState(false);
  const [isLandingPage, setIsLandingPage] = useState(false);
  const [isLandingPageNews, setIsLandingPageNews] = useState(false);
  const [isDashboardOrders, setIsDashboardOrders] = useState(false);
  const [isArchive, setIsArchive] = useState(false);
  const [isCustomClearances, setIsCustomClearances] = useState(false);
  const [isCustomDeclarations, setIsCustomDeclarations] = useState(false);
  const [isClientTracking, setIsClientTracking] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "DashboardOrders") {
      setIsDashboardOrders(false);
    }
    if (iscurrentState !== "Users") {
      setIsUsers(false);
    }
    if (iscurrentState !== "Employees") {
      setIsEmployees(false);
    }
    if (iscurrentState !== "ReferenceInformation") {
      setIsReferenceInformation(false);
    }
    if (iscurrentState !== "Report") {
      setIsReport(false);
    }
    if (iscurrentState !== "AdditionalFees") {
      setIsAdditionalFees(false);
    }
    if (iscurrentState !== "Containers") {
      setIsContainers(false);
    }
    if (iscurrentState !== "ContainersSave") {
      setIsContainersSave(false);
    }
    if (iscurrentState !== "ContainersFees") {
      setIsContainersFees(false);
    }
    if (iscurrentState !== "ContainersType") {
      setIsContainersType(false);
    }
    if (iscurrentState !== "Settings") {
      setIsSettings(false);
    }
    if (iscurrentState !== "Vehicles") {
      setIsVehicles(false);
    }
    if (iscurrentState !== "Orders") {
      setIsOrders(false);
    }
    if (iscurrentState !== "LContainers") {
      setIsLContainers(false);
    }
    if (iscurrentState !== "VFClients") {
      setIsVFClients(false);
    }
    if (iscurrentState !== "ClientContainers") {
      setIsClientContainers(false);
    }
    if (iscurrentState !== "VFCalculation") {
      setIsVFCalculation(false);
    }
    if (iscurrentState !== "Tracking") {
      setIsTracking(false);
    }
    if (iscurrentState !== "LGCompanies") {
      setIsLGCompanies(false);
    }
    if (iscurrentState !== "WarehouseRoot") {
      setIsWarehouseRoot(false);
    }
    if (iscurrentState !== "Invoices") {
      setIsInvoices(false);
    }
    if (iscurrentState !== "MInvoices") {
      setIsMInvoices(false);
    }
    if (iscurrentState !== "OInvoices") {
      setIsOInvoices(false);
    }
    if (iscurrentState !== "FRtransactions") {
      setIsFRtransactions(false);
    }
    if (iscurrentState !== "Documents") {
      setIsDocuments(false);
    }
    if (iscurrentState !== "Requests") {
      setIsRequests(false);
    }
    if (iscurrentState !== "CRequests") {
      setIsCRequests(false);
    }
    if (iscurrentState !== "TempWarehouse") {
      setIsTempWarehouse(false);
    }
    if (iscurrentState !== "GTARoot") {
      setIsGTARoot(false);
    }
    if (iscurrentState !== "Quotes") {
      setIsQuotes(false);
    }
    if (iscurrentState !== "WebQuotation") {
      setIsWebQuotation(false);
    }
    if (iscurrentState !== "LandingPage") {
      setIsLandingPage(false);
    }
    if (iscurrentState !== "LandingPageNews") {
      setIsLandingPageNews(false);
    }
    if (iscurrentState !== "Archive") {
      setIsArchive(false);
    }
    if (iscurrentState !== "Archive") {
      setIsArchive(false);
    }
    if (iscurrentState !== "CustomClearances") {
      setIsCustomClearances(false);
    }
    if (iscurrentState !== "CustomDeclarations") {
      setIsCustomDeclarations(false);
    }
    if (iscurrentState !== "ClientTracking") {
      setIsClientTracking(false);
    }
  }, [
    history,
    iscurrentState,
    isUsers,
    isEmployees,
    isReferenceInformation,
    isReport,
    isAdditionalFees,
    isContainers,
    isContainersFees,
    isDashboard,
    isDashboardOrders,
    isSettings,
    isVehicles,
    isOrders,
    isLContainers,
    isVFClients,
    isClientContainers,
    isVFCalculation,
    isTracking,
    isLGCompanies,
    isWarehouseRoot,
    isDocuments,
    isRequests,
    isCRequests,
    isInvoices,
    isMInvoices,
    isOInvoices,
    isFRtransactions,
    isTempWarehouse,
    isGTARoot,
    isQuotes,
    isWebQuotation,
    isLandingPage,
    isLandingPageNews,
    isArchive,
    isCustomClearances,
    isCustomDeclarations,
    isClientTracking,
  ]);

  const menuFullItems = [
    {
      label: "Терминалын газар",
      isHeader: true,
    },
    {
      id: "dashboards",
      label: "Хянах самбар",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Dashboard");
      },
    },
    {
      id: "referenceInformation",
      label: "Лавлах мэдээлэл",
      icon: "ri-stack-line",
      link: "/#",
      stateVariables: isReferenceInformation,
      click: function (e) {
        e.preventDefault();
        setIsReferenceInformation(!isReferenceInformation);
        setIscurrentState("ReferenceInformation");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "companies",
          label: "Харилцагч компаниуд",
          link: "/companies",
          parentId: "referenceInformation",
        },
        {
          id: "addfees",
          label: "Нэмэлт хураамжийн тохиргоо",
          link: "/addfees",
          parentId: "referenceInformation",
        },
      ],
    },
    {
      id: "report",
      label: "Тайлан",
      icon: "ri-newspaper-line",
      link: "/#",
      stateVariables: isReport,
      click: function (e) {
        e.preventDefault();
        setIsReport(!isReport);
        setIscurrentState("Report");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "vfreport",
          label: "Элдэв хураамжийн орлогын тайлан",
          link: "/vfreport",
          parentId: "report",
        },
        {
          id: "balance",
          label: "Харилцагчдын дансны тооцоо",
          link: "/balance",
          parentId: "report",
        },
        {
          id: "minvoices",
          label: "Нэхэмжлэх",
          link: "/minvoices",
          parentId: "report",
        },
      ],
    },
    // {
    //   id: "containers",
    //   label: "Талбайн бүртгэл",
    //   icon: "ri-table-line",
    //   link: "/containers",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIscurrentState("Containers");
    //   },
    // },
    {
      id: "fees",
      label: "Талбайн тооцоо | Бүртгэл",
      icon: "ri-calculator-line",
      link: "/fees",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("ContainersFees");
      },
    },
    {
      id: "vehicles",
      label: "Тээврийн хэрэгсэл",
      icon: "ri-car-line",
      link: "/vehicles",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Vehicles");
      },
    },
    {
      id: "warehouseroot",
      label: "Гаалийн баталгаат агуулах (ГБА)",
      icon: "ri-home-3-line",
      link: "/warehouseroot",
      stateVariables: isWarehouseRoot,
      click: function (e) {
        e.preventDefault();
        setIsWarehouseRoot(!isWarehouseRoot);
        setIscurrentState("WarehouseRoot");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "vfreport",
          label: "Орлого",
          link: "/warehousein",
          parentId: "warehouseroot",
        },
        {
          id: "warehouseout",
          label: "Зарлага",
          link: "/warehouseout",
          parentId: "warehouseroot",
        },
        {
          id: "warehousereport",
          label: "Товчоо | Нэхэмжлэх",
          link: "/warehousereport",
          parentId: "warehouseroot",
        },
        // {
        //   id: "warehouseregistration",
        //   label: "Бүртгэл",
        //   link: "/warehouse",
        //   parentId: "warehouseroot",
        //   badgeName: "Old",
        //   badgeColor: "danger",
        // },
        // {
        //   id: "invoices",
        //   label: "Нэхэмжлэх",
        //   link: "/invoices",
        //   parentId: "warehouseroot",
        //   badgeName: "Old",
        //   badgeColor: "danger",
        // },
      ],
    },
    {
      id: "gtaroot",
      label: "Гаалийн түр агуулах (ГТА)",
      icon: "ri-store-3-line",
      link: "/#",
      stateVariables: isGTARoot,
      click: function (e) {
        e.preventDefault();
        setIsGTARoot(!isGTARoot);
        setIscurrentState("GTARoot");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "gtain",
          label: "Орлого",
          link: "/gtain",
          parentId: "gtaroot",
        },
        {
          id: "gtaout",
          label: "Зарлага",
          link: "/gtaout",
          parentId: "gtaroot",
        },
        {
          id: "gtasummary",
          label: "Үлдэгдэл",
          link: "/gtasummary",
          parentId: "gtaroot",
        },
      ],
    },
    {
      label: "ЗУХЭГ, Хүний нөөц",
      isHeader: true,
    },
    {
      id: "employees",
      label: "Ажилтнуудын бүртгэл",
      icon: "ri-account-circle-line",
      link: "/employees",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Employees");
      },
    },
    {
      id: "documents",
      label: "Баримт бичгийн бүртгэл",
      icon: "ri-archive-drawer-line",
      link: "/documents",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Documents");
      },
    },
    {
      id: "archive",
      label: "Архив",
      icon: "ri-archive-line",
      badgeName: "New",
      badgeColor: "success",
      link: "/archive",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Archive");
      },
    },
    {
      id: "requests",
      label: "Хүсэлтүүд",
      icon: "ri-file-copy-2-fill",
      link: "/requests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Requests");
      },
    },
    {
      id: "users",
      label: "Системийн тохиргоо",
      icon: "ri-account-circle-line",
      link: "/users",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Users");
      },
    },
    {
      id: "logs",
      label: "Log бүртгэл",
      icon: "ri-shield-keyhole-line",
      link: "/logs",
      badgeName: "Admin",
      badgeColor: "danger",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Logs");
      },
    },
    {
      label: "Тээврийн газар",
      isHeader: true,
    },
    {
      id: "dashboards",
      label: "Хянах самбар",
      icon: "ri-dashboard-2-line",
      link: "/dashboard-orders",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("DashboardOrders");
      },
    },
    {
      id: "lgcompanies",
      label: "Харилцагч компаниуд",
      icon: "ri-community-line",
      link: "/lgcompanies",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("LGCompanies");
      },
    },
    {
      id: "wquotes",
      label: "Үнийн санал",
      icon: "ri-todo-line",
      link: "/wquotes",
      badgeName: "Web",
      badgeColor: "success",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("WebQuotation");
      },
    },
    {
      id: "quotes",
      label: "Үнийн санал",
      icon: "ri-survey-line",
      link: "/quotes",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Quotes");
      },
    },
    {
      id: "tracking",
      label: "Захиалга | Замын мэдээ",
      icon: "ri-file-list-3-line",
      link: "/tracking",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Tracking");
      },
    },
    {
      id: "oinvoices",
      label: "Нэхэмжлэх",
      icon: "ri-file-copy-2-fill",
      link: "/oinvoices",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("OInvoices");
      },
    },
    {
      id: "frtransactions",
      label: "Гадаад шилжүүлэг",
      icon: "ri-refund-2-line",
      link: "/frtransactions",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("FRtransactions");
      },
    },
    {
      id: "customclearances",
      label: "Гаалийн бүрдүүлэлт",
      icon: "ri-currency-fill",
      link: "/customclearances",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CustomClearances");
      },
    },
    {
      id: "customdeclarations",
      label: "Гаалийн мэдүүлэг",
      icon: "ri-checkbox-multiple-line",
      link: "/customdeclarations",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CustomDeclarations");
      },
    },
    {
      label: "Вэб сайт",
      isHeader: true,
    },
    {
      id: "landingpage",
      label: "Үндсэн контент",
      icon: "ri-earth-line",
      link: "/landing",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("LandingPage");
      },
    },
    {
      id: "jobposts",
      label: "Ажлын зар",
      icon: "ri-briefcase-4-line",
      link: "/jobposts",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("JobPosts");
      },
    },
    {
      id: "news",
      label: "Мэдээ",
      icon: "ri-newspaper-line",
      link: "/news",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("News");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuSemiFullItems = [
    {
      label: "Терминалын газар",
      isHeader: true,
    },
    {
      id: "dashboards",
      label: "Хянах самбар",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Dashboard");
      },
    },
    {
      id: "referenceInformation",
      label: "Лавлах мэдээлэл",
      icon: "ri-stack-line",
      link: "/#",
      stateVariables: isReferenceInformation,
      click: function (e) {
        e.preventDefault();
        setIsReferenceInformation(!isReferenceInformation);
        setIscurrentState("ReferenceInformation");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "companies",
          label: "Харилцагч компаниуд",
          link: "/companies",
          parentId: "referenceInformation",
        },
        {
          id: "addfees",
          label: "Нэмэлт хураамжийн тохиргоо",
          link: "/addfees",
          parentId: "referenceInformation",
        },
      ],
    },
    {
      id: "report",
      label: "Тайлан",
      icon: "ri-newspaper-line",
      link: "/#",
      stateVariables: isReport,
      click: function (e) {
        e.preventDefault();
        setIsReport(!isReport);
        setIscurrentState("Report");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "vfreport",
          label: "Элдэв хураамжийн орлогын тайлан",
          link: "/vfreport",
          parentId: "report",
        },
        {
          id: "balance",
          label: "Харилцагчдын дансны тооцоо",
          link: "/balance",
          parentId: "report",
        },
        {
          id: "minvoices",
          label: "Нэхэмжлэх",
          link: "/minvoices",
          parentId: "report",
        },
      ],
    },
    {
      id: "fees",
      label: "Талбайн тооцоо | Бүртгэл",
      icon: "ri-calculator-line",
      link: "/fees",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("ContainersFees");
      },
    },
    {
      id: "vehicles",
      label: "Тээврийн хэрэгсэл",
      icon: "ri-car-line",
      link: "/vehicles",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Vehicles");
      },
    },
    {
      id: "warehouseroot",
      label: "Гаалийн баталгаат агуулах (ГБА)",
      icon: "ri-home-3-line",
      link: "/warehouseroot",
      stateVariables: isWarehouseRoot,
      click: function (e) {
        e.preventDefault();
        setIsWarehouseRoot(!isWarehouseRoot);
        setIscurrentState("WarehouseRoot");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "vfreport",
          label: "Орлого",
          link: "/warehousein",
          parentId: "warehouseroot",
        },
        {
          id: "warehouseout",
          label: "Зарлага",
          link: "/warehouseout",
          parentId: "warehouseroot",
        },
        {
          id: "warehousereport",
          label: "Товчоо | Нэхэмжлэх",
          link: "/warehousereport",
          parentId: "warehouseroot",
        },
      ],
    },
    {
      id: "gtaroot",
      label: "Гаалийн түр агуулах (ГТА)",
      icon: "ri-store-3-line",
      link: "/#",
      stateVariables: isGTARoot,
      click: function (e) {
        e.preventDefault();
        setIsGTARoot(!isGTARoot);
        setIscurrentState("GTARoot");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "gtain",
          label: "Орлого",
          link: "/gtain",
          parentId: "gtaroot",
        },
        {
          id: "gtaout",
          label: "Зарлага",
          link: "/gtaout",
          parentId: "gtaroot",
        },
        {
          id: "gtasummary",
          label: "Үлдэгдэл",
          link: "/gtasummary",
          parentId: "gtaroot",
        },
      ],
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuSpecialItems = [
    {
      label: "ЗУХЭГ, Хүний нөөц",
      isHeader: true,
    },
    {
      id: "documents",
      label: "Баримт бичгийн бүртгэл",
      icon: "ri-archive-drawer-line",
      link: "/documents",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Documents");
      },
    },
    {
      label: "Терминалын газар",
      isHeader: true,
    },
    {
      id: "dashboards",
      label: "Хянах самбар",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Dashboard");
      },
    },
    {
      id: "referenceInformation",
      label: "Лавлах мэдээлэл",
      icon: "ri-stack-line",
      link: "/#",
      stateVariables: isReferenceInformation,
      click: function (e) {
        e.preventDefault();
        setIsReferenceInformation(!isReferenceInformation);
        setIscurrentState("ReferenceInformation");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "companies",
          label: "Харилцагч компаниуд",
          link: "/companies",
          parentId: "referenceInformation",
        },
        {
          id: "addfees",
          label: "Нэмэлт хураамжийн тохиргоо",
          link: "/addfees",
          parentId: "referenceInformation",
        },
      ],
    },
    {
      id: "report",
      label: "Тайлан",
      icon: "ri-newspaper-line",
      link: "/#",
      stateVariables: isReport,
      click: function (e) {
        e.preventDefault();
        setIsReport(!isReport);
        setIscurrentState("Report");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "vfreport",
          label: "Элдэв хураамжийн орлогын тайлан",
          link: "/vfreport",
          parentId: "report",
        },
        {
          id: "balance",
          label: "Харилцагчдын дансны тооцоо",
          link: "/balance",
          parentId: "report",
        },
        {
          id: "minvoices",
          label: "Нэхэмжлэх",
          link: "/minvoices",
          parentId: "report",
        },
      ],
    },
    {
      id: "fees",
      label: "Талбайн тооцоо | Бүртгэл",
      icon: "ri-calculator-line",
      link: "/fees",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("ContainersFees");
      },
    },
    {
      id: "vehicles",
      label: "Тээврийн хэрэгсэл",
      icon: "ri-car-line",
      link: "/vehicles",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Vehicles");
      },
    },
    {
      id: "warehouseroot",
      label: "Гаалийн баталгаат агуулах (ГБА)",
      icon: "ri-home-3-line",
      link: "/warehouseroot",
      stateVariables: isWarehouseRoot,
      click: function (e) {
        e.preventDefault();
        setIsWarehouseRoot(!isWarehouseRoot);
        setIscurrentState("WarehouseRoot");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "vfreport",
          label: "Орлого",
          link: "/warehousein",
          parentId: "warehouseroot",
        },
        {
          id: "warehouseout",
          label: "Зарлага",
          link: "/warehouseout",
          parentId: "warehouseroot",
        },
        {
          id: "warehousereport",
          label: "Товчоо | Нэхэмжлэх",
          link: "/warehousereport",
          parentId: "warehouseroot",
        },
      ],
    },
    {
      id: "gtaroot",
      label: "Гаалийн түр агуулах (ГТА)",
      icon: "ri-store-3-line",
      link: "/#",
      stateVariables: isGTARoot,
      click: function (e) {
        e.preventDefault();
        setIsGTARoot(!isGTARoot);
        setIscurrentState("GTARoot");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "gtain",
          label: "Орлого",
          link: "/gtain",
          parentId: "gtaroot",
        },
        {
          id: "gtaout",
          label: "Зарлага",
          link: "/gtaout",
          parentId: "gtaroot",
        },
        {
          id: "gtasummary",
          label: "Үлдэгдэл",
          link: "/gtasummary",
          parentId: "gtaroot",
        },
      ],
    },
    {
      label: "Тээврийн газар",
      isHeader: true,
    },
    {
      id: "lgcompanies",
      label: "Харилцагч компаниуд",
      icon: "ri-community-line",
      link: "/lgcompanies",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("LGCompanies");
      },
    },
    {
      id: "wquotes",
      label: "Үнийн санал",
      icon: "ri-todo-line",
      link: "/wquotes",
      badgeName: "Web",
      badgeColor: "success",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("WebQuotation");
      },
    },
    {
      id: "quotes",
      label: "Үнийн санал",
      icon: "ri-survey-line",
      link: "/quotes",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Quotes");
      },
    },
    {
      id: "tracking",
      label: "Захиалга | Замын мэдээ",
      icon: "ri-file-list-3-line",
      link: "/tracking",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Tracking");
      },
    },
    {
      id: "lcontainers",
      label: "Талбайн бүртгэл",
      icon: "ri-table-line",
      link: "/lcontainers",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("LContainers");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuTovarItems = [
    {
      label: "Терминалын газар",
      isHeader: true,
    },
    {
      id: "dashboards",
      label: "Хянах самбар",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Dashboard");
      },
    },
    {
      id: "referenceInformation",
      label: "Лавлах мэдээлэл",
      icon: "ri-stack-line",
      link: "/#",
      stateVariables: isReferenceInformation,
      click: function (e) {
        e.preventDefault();
        setIsReferenceInformation(!isReferenceInformation);
        setIscurrentState("ReferenceInformation");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "companies",
          label: "Харилцагч компаниуд",
          link: "/companies",
          parentId: "referenceInformation",
        },
        {
          id: "addfees",
          label: "Нэмэлт хураамжийн тохиргоо",
          link: "/addfees",
          parentId: "referenceInformation",
        },
      ],
    },
    {
      id: "report",
      label: "Тайлан",
      icon: "ri-newspaper-line",
      link: "/#",
      stateVariables: isReport,
      click: function (e) {
        e.preventDefault();
        setIsReport(!isReport);
        setIscurrentState("Report");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "vfreport",
          label: "Элдэв хураамжийн орлогын тайлан",
          link: "/vfreport",
          parentId: "report",
        },
        {
          id: "balance",
          label: "Харилцагчдын дансны тооцоо",
          link: "/balance",
          parentId: "report",
        },
      ],
    },
    {
      id: "fees",
      label: "Талбайн тооцоо | Бүртгэл",
      icon: "ri-calculator-line",
      link: "/fees",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("ContainersFees");
      },
    },
    {
      id: "vehicles",
      label: "Тээврийн хэрэгсэл",
      icon: "ri-car-line",
      link: "/vehicles",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Vehicles");
      },
    },
    {
      id: "gtaroot",
      label: "Гаалийн түр агуулах (ГТА)",
      icon: "ri-store-3-line",
      link: "/#",
      stateVariables: isGTARoot,
      click: function (e) {
        e.preventDefault();
        setIsGTARoot(!isGTARoot);
        setIscurrentState("GTARoot");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "gtain",
          label: "Орлого",
          link: "/gtain",
          parentId: "gtaroot",
        },
        {
          id: "gtaout",
          label: "Зарлага",
          link: "/gtaout",
          parentId: "gtaroot",
        },
        {
          id: "gtasummary",
          label: "Үлдэгдэл",
          link: "/gtasummary",
          parentId: "gtaroot",
        },
      ],
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuWarehouseItems = [
    {
      label: "Терминалын газар",
      isHeader: true,
    },
    {
      id: "referenceInformation",
      label: "Лавлах мэдээлэл",
      icon: "ri-stack-line",
      link: "/#",
      stateVariables: isReferenceInformation,
      click: function (e) {
        e.preventDefault();
        setIsReferenceInformation(!isReferenceInformation);
        setIscurrentState("ReferenceInformation");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "companies",
          label: "Харилцагч компаниуд",
          link: "/companies",
          parentId: "referenceInformation",
        },
        {
          id: "addfees",
          label: "Нэмэлт хураамжийн тохиргоо",
          link: "/addfees",
          parentId: "referenceInformation",
        },
      ],
    },
    {
      id: "report",
      label: "Тайлан",
      icon: "ri-newspaper-line",
      link: "/#",
      stateVariables: isReport,
      click: function (e) {
        e.preventDefault();
        setIsReport(!isReport);
        setIscurrentState("Report");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "vfreport",
          label: "Элдэв хураамжийн орлогын тайлан",
          link: "/vfreport",
          parentId: "report",
        },
        {
          id: "balance",
          label: "Харилцагчдын дансны тооцоо",
          link: "/balance",
          parentId: "report",
        },
      ],
    },
    {
      id: "warehouseroot",
      label: "Гаалийн баталгаат агуулах (ГБА)",
      icon: "ri-home-3-line",
      link: "/warehouseroot",
      stateVariables: isWarehouseRoot,
      click: function (e) {
        e.preventDefault();
        setIsWarehouseRoot(!isWarehouseRoot);
        setIscurrentState("WarehouseRoot");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "vfreport",
          label: "Орлого",
          link: "/warehousein",
          parentId: "warehouseroot",
        },
        {
          id: "warehouseout",
          label: "Зарлага",
          link: "/warehouseout",
          parentId: "warehouseroot",
        },
        {
          id: "warehousereport",
          label: "Товчоо | Нэхэмжлэх",
          link: "/warehousereport",
          parentId: "warehouseroot",
        },
      ],
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuGTAItems = [
    {
      label: "Терминалын газар",
      isHeader: true,
    },
    {
      id: "gtaroot",
      label: "Гаалийн түр агуулах (ГТА)",
      icon: "ri-store-3-line",
      link: "/#",
      stateVariables: isGTARoot,
      click: function (e) {
        e.preventDefault();
        setIsGTARoot(!isGTARoot);
        setIscurrentState("GTARoot");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "gtain",
          label: "Орлого",
          link: "/gtain",
          parentId: "gtaroot",
        },
        {
          id: "gtaout",
          label: "Зарлага",
          link: "/gtaout",
          parentId: "gtaroot",
        },
        {
          id: "gtasummary",
          label: "Үлдэгдэл",
          link: "/gtasummary",
          parentId: "gtaroot",
        },
      ],
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
  ];

  const menuTHDItems = [
    {
      label: "Терминалын газар",
      isHeader: true,
    },
    {
      id: "dashboards",
      label: "Хянах самбар",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Dashboard");
      },
    },
    {
      id: "containers",
      label: "Талбайн бүртгэл",
      icon: "ri-table-line",
      link: "/containers",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Containers");
      },
    },
    {
      id: "vehicles",
      label: "Тээврийн хэрэгсэл",
      icon: "ri-car-line",
      link: "/vehicles",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Vehicles");
      },
    },
    {
      id: "gtaroot",
      label: "Гаалийн түр агуулах (ГТА)",
      icon: "ri-store-3-line",
      link: "/#",
      stateVariables: isGTARoot,
      click: function (e) {
        e.preventDefault();
        setIsGTARoot(!isGTARoot);
        setIscurrentState("GTARoot");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "gtain",
          label: "Орлого",
          link: "/gtain",
          parentId: "gtaroot",
        },
        {
          id: "gtaout",
          label: "Зарлага",
          link: "/gtaout",
          parentId: "gtaroot",
        },
        {
          id: "gtasummary",
          label: "Үлдэгдэл",
          link: "/gtasummary",
          parentId: "gtaroot",
        },
      ],
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuAVHItems = [
    {
      label: "Терминалын газар",
      isHeader: true,
    },
    {
      id: "containers",
      label: "Талбайн бүртгэл",
      icon: "ri-table-line",
      link: "/containers",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Containers");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuCranistItems = [
    {
      label: "Терминалын газар",
      isHeader: true,
    },
    {
      id: "containers",
      label: "Талбайн бүртгэл",
      icon: "ri-table-line",
      link: "/containers",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Containers");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuTransportDirectorItems = [
    {
      label: "Тээврийн газар",
      isHeader: true,
    },
    {
      id: "dashboards",
      label: "Хянах самбар",
      icon: "ri-dashboard-2-line",
      link: "/dashboard-orders",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("DashboardOrders");
      },
    },
    {
      id: "lgcompanies",
      label: "Харилцагч компаниуд",
      icon: "ri-community-line",
      link: "/lgcompanies",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("LGCompanies");
      },
    },
    {
      id: "wquotes",
      label: "Үнийн санал",
      icon: "ri-todo-line",
      link: "/wquotes",
      badgeName: "Web",
      badgeColor: "success",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("WebQuotation");
      },
    },
    {
      id: "quotes",
      label: "Үнийн санал",
      icon: "ri-survey-line",
      link: "/quotes",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Quotes");
      },
    },
    {
      id: "tracking",
      label: "Захиалга | Замын мэдээ",
      icon: "ri-file-list-3-line",
      link: "/tracking",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Tracking");
      },
    },
    {
      id: "oinvoices",
      label: "Нэхэмжлэх",
      icon: "ri-file-copy-2-fill",
      link: "/oinvoices",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("OInvoices");
      },
    },
    {
      id: "frtransactions",
      label: "Гадаад шилжүүлэг",
      icon: "ri-refund-2-line",
      link: "/frtransactions",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("FRtransactions");
      },
    },
    {
      id: "customclearances",
      label: "Гаалийн бүрдүүлэлт",
      icon: "ri-currency-fill",
      link: "/customclearances",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CustomClearances");
      },
    },
    {
      id: "customdeclarations",
      label: "Гаалийн мэдүүлэг",
      icon: "ri-checkbox-multiple-line",
      link: "/customdeclarations",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CustomDeclarations");
      },
    },
    {
      label: "Терминалын газар",
      isHeader: true,
    },
    {
      id: "dashboards",
      label: "Хянах самбар",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Dashboard");
      },
    },
    {
      id: "containers",
      label: "Талбайн бүртгэл",
      icon: "ri-table-line",
      link: "/containers",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Containers");
      },
    },
    {
      id: "vehicles",
      label: "Тээврийн хэрэгсэл",
      icon: "ri-car-line",
      link: "/vhclient",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Vehicles");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuTransportDivisionItems = [
    {
      label: "Тээврийн газар",
      isHeader: true,
    },
    {
      id: "dashboards",
      label: "Хянах самбар",
      icon: "ri-dashboard-2-line",
      link: "/dashboard-orders",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("DashboardOrders");
      },
    },
    {
      id: "lgcompanies",
      label: "Харилцагч компаниуд",
      icon: "ri-community-line",
      link: "/lgcompanies",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("LGCompanies");
      },
    },
    {
      id: "wquotes",
      label: "Үнийн санал",
      icon: "ri-todo-line",
      link: "/wquotes",
      badgeName: "Web",
      badgeColor: "success",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("WebQuotation");
      },
    },
    {
      id: "quotes",
      label: "Үнийн санал",
      icon: "ri-survey-line",
      link: "/quotes",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Quotes");
      },
    },
    {
      id: "tracking",
      label: "Захиалга | Замын мэдээ",
      icon: "ri-file-list-3-line",
      link: "/tracking",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Tracking");
      },
    },
    {
      id: "oinvoices",
      label: "Нэхэмжлэх",
      icon: "ri-file-copy-2-fill",
      link: "/oinvoices",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("OInvoices");
      },
    },
    {
      id: "frtransactions",
      label: "Гадаад шилжүүлэг",
      icon: "ri-refund-2-line",
      link: "/frtransactions",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("FRtransactions");
      },
    },
    {
      id: "customclearances",
      label: "Гаалийн бүрдүүлэлт",
      icon: "ri-currency-fill",
      link: "/customclearances",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CustomClearances");
      },
    },
    {
      id: "customdeclarations",
      label: "Гаалийн мэдүүлэг",
      icon: "ri-checkbox-multiple-line",
      link: "/customdeclarations",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CustomDeclarations");
      },
    },
    {
      label: "Терминалын газар",
      isHeader: true,
    },
    {
      id: "dashboards",
      label: "Хянах самбар",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Dashboard");
      },
    },
    {
      id: "clientcontainers",
      label: "Талбайн бүртгэл",
      icon: "ri-table-line",
      link: "/client-containers",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("ClientContainers");
      },
    },
    {
      id: "vehicles",
      label: "Тээврийн хэрэгсэл",
      icon: "ri-car-line",
      link: "/vhclient",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Vehicles");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuTransportItems = [
    {
      label: "Тээврийн газар",
      isHeader: true,
    },
    {
      id: "dashboards",
      label: "Хянах самбар",
      icon: "ri-dashboard-2-line",
      link: "/dashboard-orders",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("DashboardOrders");
      },
    },
    {
      id: "lgcompanies",
      label: "Харилцагч компаниуд",
      icon: "ri-community-line",
      link: "/lgcompanies",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("LGCompanies");
      },
    },
    {
      id: "wquotes",
      label: "Үнийн санал",
      icon: "ri-todo-line",
      link: "/wquotes",
      badgeName: "Web",
      badgeColor: "success",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("WebQuotation");
      },
    },
    {
      id: "quotes",
      label: "Үнийн санал",
      icon: "ri-survey-line",
      link: "/quotes",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Quotes");
      },
    },
    {
      id: "tracking",
      label: "Захиалга | Замын мэдээ",
      icon: "ri-file-list-3-line",
      link: "/tracking",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Tracking");
      },
    },
    {
      id: "oinvoices",
      label: "Нэхэмжлэх",
      icon: "ri-file-copy-2-fill",
      link: "/oinvoices",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("OInvoices");
      },
    },
    {
      id: "frtransactions",
      label: "Гадаад шилжүүлэг",
      icon: "ri-refund-2-line",
      link: "/frtransactions",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("FRtransactions");
      },
    },
    {
      label: "Терминалын газар",
      isHeader: true,
    },
    {
      id: "clientcontainers",
      label: "Талбайн бүртгэл",
      icon: "ri-table-line",
      link: "/client-containers",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("ClientContainers");
      },
    },
    {
      id: "vehicles",
      label: "Тээврийн хэрэгсэл",
      icon: "ri-car-line",
      link: "/vhclient",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Vehicles");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuHRItems = [
    {
      label: "ЗУХЭГ, Хүний нөөц",
      isHeader: true,
    },
    {
      id: "employees",
      label: "Ажилтнуудын бүртгэл",
      icon: "ri-account-circle-line",
      link: "/employees",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Employees");
      },
    },
    {
      id: "documents",
      label: "Баримт бичгийн бүртгэл",
      icon: "ri-archive-drawer-line",
      link: "/documents",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Documents");
      },
    },
    {
      id: "archive",
      label: "Архив",
      icon: "ri-archive-line",
      badgeName: "New",
      badgeColor: "success",
      link: "/archive",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Archive");
      },
    },
    {
      id: "requests",
      label: "Хүсэлтүүд",
      icon: "ri-file-copy-2-fill",
      link: "/requests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Requests");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
    {
      label: "Вэб сайт",
      isHeader: true,
    },
    {
      id: "jobposts-hr",
      label: "Ажлын зар",
      icon: "ri-briefcase-4-line",
      link: "/jobposts",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("JobPosts");
      },
    },
    {
      id: "news-hr",
      label: "Мэдээ",
      icon: "ri-newspaper-line",
      link: "/news",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("News");
      },
    },
  ];

  // Аудитор — зөвхөн Тээврийн хэрэгсэл хэсгийг УНШИХ эрхтэй.
  // Бусад цэс огт харагдахгүй.
  const menuAuditorItems = [
    {
      label: "Тээвэр",
      isHeader: true,
    },
    {
      id: "vehicles-auditor",
      label: "Тээврийн хэрэгсэл",
      icon: "ri-car-line",
      link: "/vehicles",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Vehicles");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings-auditor",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
  ];

  const menuBizResearchItems = [
    {
      label: "Вэб сайт",
      isHeader: true,
    },
    {
      id: "news-biz",
      label: "Мэдээ",
      icon: "ri-newspaper-line",
      link: "/news",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("News");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings-biz",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
  ];

  const menuArchiveItems = [
    {
      label: "ЗУХЭГ, Хүний нөөц",
      isHeader: true,
    },
    {
      id: "documents",
      label: "Баримт бичгийн бүртгэл",
      icon: "ri-archive-drawer-line",
      link: "/documents",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Documents");
      },
    },
    {
      id: "archive",
      label: "Архив",
      icon: "ri-archive-line",
      badgeName: "New",
      badgeColor: "success",
      link: "/archive",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Archive");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuFinanceItems = [
    {
      label: "Терминалын газар",
      isHeader: true,
    },
    {
      id: "dashboards",
      label: "Хянах самбар",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Dashboard");
      },
    },
    {
      id: "referenceInformation",
      label: "Лавлах мэдээлэл",
      icon: "ri-stack-line",
      link: "/#",
      stateVariables: isReferenceInformation,
      click: function (e) {
        e.preventDefault();
        setIsReferenceInformation(!isReferenceInformation);
        setIscurrentState("ReferenceInformation");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "companies",
          label: "Харилцагч компаниуд",
          link: "/companies",
          parentId: "referenceInformation",
        },
        {
          id: "addfees",
          label: "Нэмэлт хураамжийн тохиргоо",
          link: "/addfees",
          parentId: "referenceInformation",
        },
      ],
    },
    {
      id: "report",
      label: "Тайлан",
      icon: "ri-newspaper-line",
      link: "/#",
      stateVariables: isReport,
      click: function (e) {
        e.preventDefault();
        setIsReport(!isReport);
        setIscurrentState("Report");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "balance",
          label: "Харилцагчдын дансны тооцоо",
          link: "/balance",
          parentId: "report",
        },
      ],
    },
    {
      id: "containers",
      label: "Талбайн бүртгэл",
      icon: "ri-table-line",
      link: "/containers",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Containers");
      },
    },
    {
      id: "minvoices",
      label: "Нэхэмжлэх /Товар/",
      icon: "ri-todo-line",
      link: "/minvoices",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("MInvoices");
      },
    },
    {
      id: "warehouseroot",
      label: "Гаалийн баталгаат агуулах (ГБА)",
      icon: "ri-home-3-line",
      link: "/warehouseroot",
      stateVariables: isWarehouseRoot,
      click: function (e) {
        e.preventDefault();
        setIsWarehouseRoot(!isWarehouseRoot);
        setIscurrentState("WarehouseRoot");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "vfreport",
          label: "Орлого",
          link: "/warehousein",
          parentId: "warehouseroot",
        },
        {
          id: "warehouseout",
          label: "Зарлага",
          link: "/warehouseout",
          parentId: "warehouseroot",
        },
        {
          id: "warehousereport",
          label: "Товчоо | Нэхэмжлэх",
          link: "/warehousereport",
          parentId: "warehouseroot",
        },
      ],
    },
    {
      label: "Тээврийн газар",
      isHeader: true,
    },
    {
      id: "dashboards",
      label: "Хянах самбар",
      icon: "ri-dashboard-2-line",
      link: "/dashboard-orders",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("DashboardOrders");
      },
    },
    {
      id: "lgcompanies",
      label: "Харилцагч компаниуд",
      icon: "ri-community-line",
      link: "/lgcompanies",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("LGCompanies");
      },
    },
    {
      id: "tracking",
      label: "Захиалга | Замын мэдээ",
      icon: "ri-file-list-3-line",
      link: "/tracking",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Tracking");
      },
    },
    {
      id: "oinvoices",
      label: "Нэхэмжлэх",
      icon: "ri-file-copy-2-fill",
      link: "/oinvoices",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("OInvoices");
      },
    },
    {
      id: "frtransactions",
      label: "Гадаад шилжүүлэг",
      icon: "ri-refund-2-line",
      link: "/frtransactions",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("FRtransactions");
      },
    },
    {
      id: "customclearances",
      label: "Гаалийн бүрдүүлэлт",
      icon: "ri-currency-fill",
      link: "/customclearances",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CustomClearances");
      },
    },
    {
      id: "customdeclarations",
      label: "Гаалийн мэдүүлэг",
      icon: "ri-checkbox-multiple-line",
      link: "/customdeclarations",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CustomDeclarations");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuBrokerItems = [
    {
      label: "Тээврийн газар",
      isHeader: true,
    },
    {
      id: "customclearances",
      label: "Гаалийн бүрдүүлэлт",
      icon: "ri-currency-fill",
      link: "/customclearances",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CustomClearances");
      },
    },
    {
      label: "Терминалын газар",
      isHeader: true,
    },
    {
      id: "containers",
      label: "Талбайн бүртгэл",
      icon: "ri-table-line",
      link: "/bcontainers",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Containers");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuInformantItems = [
    {
      label: "Тээврийн газар",
      isHeader: true,
    },
    {
      id: "customdeclarations",
      label: "Гаалийн мэдүүлэг",
      icon: "ri-checkbox-multiple-line",
      link: "/customdeclarations",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CustomDeclarations");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
    {
      id: "crequests",
      label: "Хүсэлт",
      badgeName: "New",
      badgeColor: "success",
      icon: "ri-file-copy-2-fill",
      link: "/crequests",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("CRequests");
      },
    },
  ];

  const menuClientsLeaderItems = [
    {
      label: "Ти Ай Ложистик Терминал",
      isHeader: true,
    },
    {
      id: "vfcalc",
      label: "Дансны тооцоо",
      icon: "ri-calculator-line",
      link: "/vfcalc",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("VFCalculation");
      },
    },
    {
      id: "vfclients",
      label: "Элдэв хураамжийн тайлан",
      icon: "ri-newspaper-line",
      link: "/vfclient",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("VFClient");
      },
    },
    {
      id: "clientcontainers",
      label: "Талбайн бүртгэл",
      icon: "ri-table-line",
      link: "/client-containers",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("ClientContainers");
      },
    },
    {
      id: "vehicles",
      label: "Тээврийн хэрэгсэл",
      icon: "ri-car-line",
      link: "/vhclient",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Vehicles");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
  ];

  const menuClientsTManagerItems = [
    {
      label: "Ти Ай Ложистик Терминал",
      isHeader: true,
    },
    {
      id: "clientcontainers",
      label: "Талбайн бүртгэл",
      icon: "ri-table-line",
      link: "/client-containers",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("ClientContainers");
      },
    },
    {
      id: "vehicles",
      label: "Тээврийн хэрэгсэл",
      icon: "ri-car-line",
      link: "/vhclient",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Vehicles");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
  ];

  const menuTransportClientsItems = [
    {
      label: "Ти Ай Ложистик ХХК",
      isHeader: true,
    },
    {
      id: "clienttracking",
      label: "Захиалга | Замын мэдээ",
      icon: "ri-file-list-3-line",
      link: "/client-tracking",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("ClientTracking");
      },
    },
    {
      label: "Хувийн тохиргоо",
      isHeader: true,
    },
    {
      id: "user-settings",
      label: "Нууц үг солих",
      icon: "ri-lock-password-line",
      link: "/user-settings",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Settings");
      },
    },
  ];

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const role = authUser?.role;
  const type = authUser?.type;
  const company = authUser?.company;
  const department = authUser?.department;
  const section = authUser?.section;
  const isLeader = authUser?.isLeader;

  const defaultRoleMenuMap = {
    "Гүйцэтгэх захирал": menuSemiFullItems,
    "Терминалын газрын захирал": menuSemiFullItems,
    "Товарын хэлтсийн дарга": menuSemiFullItems,
    "Терминалын хэлтсийн дарга": menuTHDItems,
    "Авто ачигчийн жолооч": menuTHDItems,
    Кассир: menuTovarItems,
    "Ачаа вагон хүлээлцэгч": menuAVHItems,
    "Механик инженер": menuCranistItems,
    Кранист: menuCranistItems,
    "Агуулахын эрхлэгч /ГБА/": menuWarehouseItems,
    "Агуулахын эрхлэгч /ГТА/": menuGTAItems,
    "Захиргаа удирдлага, санхүүгийн газрын захирал": menuHRItems,
    "Хүний нөөц, чанарын хэлтсийн дарга": menuHRItems,
    "Зах зээл, бизнесийн судалгааны мэргэжилтэн": menuBizResearchItems,
    "Архив, бичиг хэргийн ажилтан": menuArchiveItems,
    "Ахлах нягтлан бодогч": menuArchiveItems,
    "Ахлах гаалийн бүртгэгдсэн мэргэжилтэн": menuInformantItems,
    "Гаалийн бүртгэгдсэн мэргэжилтэн": menuInformantItems,
  };

  let menuToRender;

  if (role === "Админ") {
    menuToRender = menuFullItems;
  } else if (role === "Аудитор") {
    // Компани/газраас үл хамааран цорын ганц цэс — эрхийн хүрээ тодорхой
    menuToRender = menuAuditorItems;
  } else if (role === "Зах зээл, бизнесийн судалгааны мэргэжилтэн") {
    menuToRender = menuBizResearchItems;
  } else if (company === "TILogistic" || company === "Ти Ай Ложистик ХХК") {
    if (department === "Терминалын газар") {
      menuToRender = defaultRoleMenuMap[role];
    } else if (department === "Тээврийн газар") {
      if (role === "Тээврийн газрын захирал") {
        menuToRender = menuTransportDirectorItems;
      } else {
        if (role === "Тээврийн хэлтсийн дарга") {
          menuToRender = menuTransportDivisionItems;
        } else if (role === "Тээврийн менежер") {
          menuToRender = menuTransportItems;
        } else if (role === "Гаалийн брокер" || role === "Талбайн брокер") {
          menuToRender = menuBrokerItems;
        }
      }
    } else if (department === "Захиргаа удирдлага, санхүүгийн газар") {
      if (
        role === "Хүний нөөц, чанарын хэлтсийн дарга" ||
        role === "Захиргаа удирдлага, санхүүгийн газрын захирал"
      ) {
        menuToRender = menuHRItems;
      } else if (role === "Архив, бичиг хэргийн ажилтан") {
        menuToRender = menuArchiveItems;
      } else if (section === "Санхүүгийн хэлтэс") {
        menuToRender = menuFinanceItems;
      }
    }
  } else if (type === "Терминалын газрын хэрэглэгч") {
    if (isLeader === "Удирдах албан тушаалтан") {
      menuToRender = menuClientsLeaderItems;
    } else if (isLeader === "Талбайн менежер") {
      menuToRender = menuClientsTManagerItems;
    }
  } else if (type === "Тээврийн газрын хэрэглэгч") {
    menuToRender = menuTransportClientsItems;
  }

  return <React.Fragment>{menuToRender}</React.Fragment>;
};
export default Navdata;
